import { BillingTypeEnum } from '../../types/enums/cse/billing-type.enum'
import { ReductionTypeEnum } from '../../types/enums/cse/reduction-type.enum'
import { CseFilter } from '../../types/models/cse/cse'

export const transformCseFiltersToUrl = (filters?: CseFilter): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.billingTypes?.length)
    searchParams.set('billingTypes', filters.billingTypes.join(','))
  if (filters.reductionTypes?.length)
    searchParams.set('reductionTypes', filters.reductionTypes.join(','))
  if (filters.isActive !== undefined) searchParams.set('isActive', String(filters.isActive))
  if (filters.minNumberOfEmployees !== undefined)
    searchParams.set('minNumberOfEmployees', String(filters.minNumberOfEmployees))
  if (filters.maxNumberOfEmployees !== undefined)
    searchParams.set('maxNumberOfEmployees', String(filters.maxNumberOfEmployees))
  if (filters.councilAllowance !== undefined)
    searchParams.set('councilAllowance', String(filters.councilAllowance))

  return searchParams.toString()
}

export const transformUrlToCseFilters = (searchParams: URLSearchParams): CseFilter => {
  const filters: CseFilter = {}

  const billingTypes = searchParams.get('billingTypes')
  if (billingTypes) filters.billingTypes = billingTypes.split(',') as BillingTypeEnum[]

  const reductionTypes = searchParams.get('reductionTypes')
  if (reductionTypes) filters.reductionTypes = reductionTypes.split(',') as ReductionTypeEnum[]

  const isActive = searchParams.get('isActive')
  if (isActive !== null) filters.isActive = isActive === 'true'

  const minNumberOfEmployees = searchParams.get('minNumberOfEmployees')
  if (minNumberOfEmployees !== null)
    filters.minNumberOfEmployees = parseInt(minNumberOfEmployees, 10)

  const maxNumberOfEmployees = searchParams.get('maxNumberOfEmployees')
  if (maxNumberOfEmployees !== null)
    filters.maxNumberOfEmployees = parseInt(maxNumberOfEmployees, 10)

  const councilAllowance = searchParams.get('councilAllowance')
  if (councilAllowance !== null) filters.councilAllowance = councilAllowance === 'true'

  return filters
}
